import styled from "styled-components";
import { responsive } from "../../../../../styles/constants.style";

export const BulkCreateProgramUploadWrapper = styled.div`
  .name-field {
    margin: 24px 16px;
    width: 320px;
    ${responsive.MOBILE`
      margin: 0;
      padding: 16px 16px 16px 8px;
      width: 100%;
    `}
  }
  ${responsive.MOBILE`
    .file-upload-container {
      margin: 16px;
    }
  `}
  .progress-details-accordion {
    margin-top: 32px;
    .MuiCollapse-wrapper {
      margin-top: 8px;
    }
    .MuiAccordionSummary-expandIconWrapper {
      margin-left: 16px;
    }
  }
  .progress-details-accordion:last-child {
    margin-bottom: 32px;
  }
  .upload-container {
    margin-bottom: 20px;
    ${responsive.MOBILE`
      margin-bottom: 0px;
    `}
  }
`;
